import { Stack, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface Props {
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
  /** Aktionszeile am Fuß des Schrittes. Ohne Fuß endet der Schritt mit seinem Inhalt. */
  footer?: React.ReactNode;
  align?: 'left' | 'center';
}

/**
 * Der gemeinsame Rahmen jedes Schrittes: eine Überschrift, ein Satz Erklärung, der
 * Inhalt, und höchstens eine Aktionszeile.
 *
 * Vorher trug jeder Bildschirm sein eigenes Raster — mal zweispaltig mit Avatar, mal
 * zentriert, mal mit 80px Innenabstand. Dieselbe Frage sah dadurch auf jedem Schritt
 * anders aus. Der Rahmen hier hält Abstände und Textgrößen an einer Stelle.
 */
const StepLayout: React.FC<Props> = ({ title, description, children, footer, align = 'left' }) => {
  const { classes, cx } = useStyles();

  return (
    <Stack className={classes.stepLayout}>
      <Typography className={cx(classes.title, align)} component={'h2'}>
        {title}
      </Typography>
      {!_.isNil(description) ? <Typography className={cx(classes.description, align)}>{description}</Typography> : null}
      <div className={classes.content}>{children}</div>
      {!_.isNil(footer) ? <div className={classes.footer}>{footer}</div> : null}
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  stepLayout: {
    width: '100%',
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 'bold',
    lineHeight: 1.25,
    marginBottom: '6px',
    '&.center': {
      textAlign: 'center',
    },
  },
  description: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: 1.5,
    color: theme.palette.greys.medium,
    marginBottom: '22px',
    '&.center': {
      textAlign: 'center',
    },
  },
  content: {
    width: '100%',
  },
  footer: {
    marginTop: '28px',
  },
}));

export default StepLayout;
